import React, { useState } from 'react'
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import axios from "axios";
import { base_url, isLogin, postHeader, user } from '../Helpers/request';
import { useDispatch } from "react-redux";
import { cartlengthvalue } from '../Reducer/cartReducer';
import { whishlistlength } from '../Reducer/wishlistReducer';
import { sessionId } from '../Reducer/homeReducer';
import swal from "sweetalert";
import { useHistory } from "react-router-dom";
import Loader from './Loader';
import "../Assets/css/stripe.css"

export default function Stripe(props) {
    const history = useHistory();
    const [loader, setLoader] = useState(false);
    const dispatch = useDispatch();
    const stripe = useStripe();
    const elements = useElements();
    const handlelogout = () => {
        localStorage.removeItem('bw-user');
        dispatch(whishlistlength(0))
        dispatch(cartlengthvalue(0))
        dispatch(sessionId(''))
        history.push("/")
        window.location.reload(true);
    }
    const handleSubmit = async (e) => {
        setLoader(true);
        e.preventDefault();
        if (!stripe || !elements) {
            return;
        }
        const cardElement = elements.getElement(CardElement);

        const { error, token } = await stripe.createToken(cardElement);

        if (!error) {
            let payload = {
                user_id: isLogin ? user?.user_id : props?.data?.billing_address?.user_id,
                order_id: props?.data?.order_id,
                token: token?.id
            };
            axios.post(base_url + "/Stripepay/payment", payload, {
                headers: postHeader,
            })
                .then((response) => {
                    if (response.data.status == 1) {
                        setLoader(false);
                        dispatch(cartlengthvalue(0));
                        sessionStorage.removeItem("bw-checkoutdata");
                        history.push(
                            `/ordersuccess/${response.data.data.order_id}/${response.data.data.order_no}/${response.data.data.txn_id}`
                        );
                    }
                     else if (response.data.status == 2) {
                        setLoader(false);
                        handlelogout();
                    } else {
                        setLoader(false);
                        return swal(response.data.message, "", "error");
                    }
                })
                .catch((err) => {
                    setLoader(false);
                    console.log(err);
                });
        } else {
            setLoader(false);
            console.log(error);
        }
    };

    return (
        <>
            {loader ? <div className="bj_loder position-relative">
                <Loader className="loder_checkout" /> 
            </div> : ""}
            <form className='bj_stripe_form_card'>
                <h2>Card Info</h2>
                <CardElement className='card-info'/>
                <div>
                    <button className='btn bj_pay_button' onClick={handleSubmit}>PAY</button>
                </div>
            </form>
        </>
    );

}
